module.exports = __webpack_public_path__ + "img/logo.be4795c9.png";